import StatusBadge from 'components/badges/StatusBadge';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const HoldStatusBadge: FunctionComponent<Props> = ({ className = '', testId = TEST_ID, text }) => {
    const { HOLD } = useTranslation();

    return (
        <StatusBadge
            className={`${className} ${styles.holdStatusBadge}`}
            testId={testId}
            text={text ?? HOLD}
        />
    );
};

export default HoldStatusBadge;
